import { Helmet } from 'react-helmet'

export default function Home()
{
    return (
        <>
            <Helmet>
                <title> Clinic Manager | Home </title>
            </Helmet>

            <div style={{ height:'calc(100vh - 60px)', width:'100%'}} 
                 className="d-flex justify-content-center align-items-center"
            >
                <h1>Home</h1>
            </div>
        </>
    )
}
